import { defineComponent } from '@nuxtjs/composition-api';
import { mapActions, mapState } from 'vuex';
import WarRoomUnreadPostsCountQuery from '@/apollo/queries/WarRoomUnreadPostsCount.query';

const updateUnreadPostsInterval = 300000; // 5 mins in ms

export default defineComponent({
  name: 'WarRoomUnreadPostsCountMixin',
  apollo: {
    warRoomUnreadPostsCount: {
      query: WarRoomUnreadPostsCountQuery,
      error(error): void {
        this.$notice.error(error);
      },
      result({ data }) {
        if (data?.warRoomUnreadPostsCount) {
          this.updateUnreadPostsCount(data.warRoomUnreadPostsCount);
        }
      },
      pollInterval: updateUnreadPostsInterval,
      skip() {
        return !this.$auth.loggedIn;
      },
      prefetch: false,
    },
  },
  computed: {
    ...mapState('warRoom', ['unreadPostsCount', 'isUnreadPostsLabelActive']),
    unreadPostsMessage(): string | null {
      if (this.isUnreadPostsLabelActive && this.unreadPostsCount) {
        return this.unreadPostsCount > 9 ? '9+' : String(this.unreadPostsCount);
      }

      return null;
    },
  },
  methods: {
    ...mapActions('warRoom', ['updateUnreadPostsCount']),
  },
});
